export default __webpack_public_path__ + "static/media/careGreyHollow.43951db2.svg";